import Auth from '@aws-amplify/auth';
import { useEffect } from 'react';

import { getAmplifyConfig } from '../authConfig/amplify';
import { AppConfig } from '../types/app';

function useAmplifyConfig(config: AppConfig) {
  useEffect(() => {
    const amplifyConfig = getAmplifyConfig(config);
    Auth.configure(amplifyConfig.Auth);
  }, [config]);
}

export default useAmplifyConfig;
